// extracted by css-extract-rspack-plugin
export default {"userListContent":"lprXk","transitioningUserListContent":"M7AuA","userTable":"Wurav"};